export default function Philosophy() {
  return (
    <section className="section section--divider" id="philosophy">
      <div className="section__label">02 — PHILOSOPHY</div>

      <div className="philosophy">
        <div>
          <h2 className="section__headline">
            ART<br />THAT<br />WORKS.
          </h2>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
          <div className="philosophy__quote">
            "Development is not<br />decoration."
          </div>
          <p className="section__sub" style={{ marginTop: 0 }}>
            It is precision, pressure and discipline<br />
            turned into product.<br /><br />
            We don't build software.<br />
            We build things that last.
          </p>
        </div>
      </div>

      <div style={{
        width: '100%',
        height: '1px',
        background: 'linear-gradient(90deg, #CC1F1A 0%, rgba(204,31,26,0.2) 40%, transparent 100%)',
        marginTop: '80px',
      }} />
    </section>
  );
}
